import { COLORS } from '@/constants';
import { Button } from '@mui/material';
import styled from 'styled-components';

export const Head = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  margin-bottom: 30px;

  @media (max-width: 800px) {
    margin-bottom: 20px;
  }
`;

export const StyledButton = styled(Button)`
  border-color: ${COLORS.yellow} !important;
  color: ${COLORS.black} !important;
  background-color: ${COLORS.white} !important;
  padding: 10px 17.5px !important;
  max-height: 38px;
  border-radius: 6px !important;
  border-width: 2px !important;
`;

export const ListBox = styled.div`
  display: flex;
  gap: 24px;

  @media (max-width: 1280px) {
    flex-direction: column;
  }
`;

export const CardContainer = styled.div`
  display: flex;
  gap: 16px;
  flex-direction: column;

  @media (max-width: 1220px) {
    flex-direction: row;
  }

  @media (max-width: 800px) {
    flex-direction: column;
  }
`;

export const DateBadge = styled.div`
  position: absolute;
  top: 10px;
  left: 10px;
  z-index: 10;
  background: rgba(255, 255, 255, 0.85);
  border-radius: 6px;
  padding: 4px 10px;
`;

export const Preview = styled.div`
  height: 225px;
  width: 100%;
  border-radius: 8px;
  overflow: hidden;
  position: relative;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  @media (max-width: 1220px) {
    max-width: 40%;
    min-width: 40%;
  }

  @media (max-width: 800px) {
    max-width: 100%;
    min-width: 100%;
  }
`;

export const Content = styled.div`
  display: flex;
  gap: 12px;
  flex-direction: column;

  @media (max-width: 800px) {
    gap: 8px;
  }
`;
